import { atom } from 'recoil';

export const captionsEnabledState = atom({
  key: 'captionsEnabledState',
  default: true,
});

export const translationDataState = atom({
  key: 'translationDataState',
  default: null as any,
});

export const tourConfigsState = atom({
  key: 'tourConfigsState',
  default: {} as any,
});

export const forceShowPathSwitchMobileModalState = atom({
  key: 'forceShowPathSwitchMobileModalState',
  default: false,
});

export const audioConfigsState = atom({
  key: 'audioConfigsState',
  default: {
    muted: false,
    volume: 0.5,
    captionsEnabled: true,
  } as any,
});
